///////////////////////////////////////////////////
//dl-common.js
///////////////////////////////////////////////////

function DL_fadeIn(_target, _time, _callback) {
  _target.style.display = "block";
  _target.style.opacity = 0;

  var start = performance.now();
  if (!_time) {
    _time = 500;
  }
  requestAnimationFrame(function tick(timestamp) {
    var easing = (timestamp - start) / _time;
    _target.style.opacity = Math.min(easing, 1);
    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      if (_callback) {
        _callback();
      }
    }
  });
}
window.DL_fadeIn = DL_fadeIn;

function DL_fadeOut(_target, _time, _callback) {
  var start = performance.now();
  if (!_time) {
    _time = 500;
  }
  requestAnimationFrame(function tick(timestamp) {
    var easing = (timestamp - start) / _time;
    _target.style.opacity = Math.max(1 - easing, 0);
    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      _target.style.opacity = 0;
      _target.style.display = "none";
      if (_callback) {
        _callback();
      }
    }
  });
}
window.DL_fadeOut = DL_fadeOut;